<nav
  class="bg-white dark:bg-slate-900 shadow-sm dark:shadow-slate-800/50 fixed w-full top-0 z-[9999] transition-colors duration-200"
>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <a routerLink="/dashboard" class="flex items-center cursor-pointer">
        <div
          class="w-10 h-10 rounded-lg feature-icon flex items-center justify-center mr-3"
        >
          <span class="text-white text-xl font-bold">P</span>
        </div>
        <span class="text-2xl font-bold gradient-text">Predivent</span>
      </a>

      <!-- Navigation -->
      <div class="hidden md:flex items-center space-x-8">
        @if (isOnboardingCompleted() && !isDashboardActive()) {
          <a
            routerLink="/dashboard"
            routerLinkActive="text-purple-600"
            class="nav-link flex items-center gap-2"
          >
            <span>📊</span> Dashboard
          </a>
        }

        @if (isOnboardingCompleted() && !isKioskActive()) {
          <a
            routerLink="/kiosk"
            routerLinkActive="text-purple-600"
            class="nav-link flex items-center gap-2"
          >
            <span>🛒</span> Kiosk
          </a>
        }

        @if (isOnboardingCompleted() && !isEventsOrServicesActive()) {
          <a
            [routerLink]="eventsRoute()"
            routerLinkActive="text-purple-600"
            class="nav-link flex items-center gap-2"
          >
            <span>📅</span> {{ eventsLabel() }}
          </a>
        }

        @if (isOnboardingCompleted() && !isRecommendationsActive()) {
          <a
            routerLink="/recommendations"
            routerLinkActive="text-purple-600"
            class="nav-link flex items-center gap-2"
          >
            <span>💡</span> Recommandations
          </a>
        }
      </div>

      <!-- Actions -->
      <div class="flex items-center space-x-4 relative">
        <!-- Menu hamburger mobile -->
        <button
          (click)="toggleMobileMenu()"
          class="md:hidden cursor-pointer text-gray-700 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <!-- Badge type de marchand -->
        @if (isOnboardingCompleted()) {
          <span
            class="hidden md:inline-flex px-3 py-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg font-medium text-sm"
          >
            {{
              merchantType() === "fixed"
                ? "🏪 Marchand Fixe"
                : "🚚 Marchand Itinérant"
            }}
          </span>
          <!-- Badge plan -->
          <a
            routerLink="/subscription"
            class="hidden md:inline-flex px-3 py-1.5 rounded-lg font-medium text-xs cursor-pointer hover:opacity-80 transition"
            [ngClass]="planColorClass()"
          >
            {{ planLabel() }}
          </a>
        }

        <button
          (click)="toggleMenu()"
          class="cursor-pointer font-medium text-gray-700 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400 flex items-center gap-2"
        >
          <span>👤</span> Mon compte
        </button>

        @if (menuOpen()) {
          <div
            class="absolute right-0 top-12 w-64 bg-white dark:bg-slate-800 rounded-lg shadow-lg dark:shadow-slate-900/50 z-[10000] border border-gray-100 dark:border-slate-700"
          >
            <!-- Email utilisateur style Gmail -->
            <div
              class="px-4 py-3 border-b border-gray-100 dark:border-slate-700"
            >
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ userEmail() }}
              </p>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{
                  isOnboardingCompleted()
                    ? "Connecté"
                    : "Onboarding en cours..."
                }}
              </p>
            </div>
            <!-- Liens visibles uniquement après l'onboarding -->
            @if (isOnboardingCompleted()) {
              <a
                routerLink="/profile"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                👤 Mon Profil
              </a>
              <a
                routerLink="/products"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                📦 Produits
              </a>
              @if (planFeatureService.canAccess(FEATURES.ADVANCED_STATS)) {
                <a
                  routerLink="/kiosk/stats"
                  (click)="toggleMenu()"
                  class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
                >
                  📈 Stats
                </a>
              } @else {
                <a
                  routerLink="/subscription"
                  (click)="toggleMenu()"
                  class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer text-gray-400 dark:text-gray-500 dark:text-gray-400"
                >
                  📈 Stats
                  <span
                    class="ml-1 text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 px-1.5 py-0.5 rounded font-semibold"
                    >🔒 Pro</span
                  >
                </a>
              }
              <a
                routerLink="/kiosk/history"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                🕐 Historique
              </a>
              <a
                routerLink="/settings"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer border-t border-gray-100 dark:border-slate-700 dark:text-gray-200"
              >
                ⚙️ Paramètres
              </a>
              <a
                routerLink="/subscription"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                💳 Abonnement
              </a>
              <a
                routerLink="/invoices"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                🧾 Mes factures
              </a>
              <a
                routerLink="/billing-profile"
                (click)="toggleMenu()"
                class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              >
                🏢 Infos de facturation
              </a>
            }
            <button
              (click)="logout()"
              class="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 cursor-pointer dark:text-gray-200"
              [class.border-t]="isOnboardingCompleted()"
              [class.border-gray-100]="isOnboardingCompleted()"
              [class.dark:border-slate-700]="isOnboardingCompleted()"
            >
              🚪 Déconnexion
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Menu mobile -->
  @if (mobileMenuOpen()) {
    <div
      class="md:hidden border-t border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900"
    >
      <div class="px-4 py-2 space-y-1">
        @if (isOnboardingCompleted() && !isDashboardActive()) {
          <a
            routerLink="/dashboard"
            routerLinkActive="bg-purple-50 dark:bg-purple-900/20 text-purple-600"
            (click)="closeMobileMenu()"
            class="block px-4 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800 flex items-center gap-3 dark:text-gray-200"
          >
            <span>📊</span> Dashboard
          </a>
        }
        @if (isOnboardingCompleted() && !isKioskActive()) {
          <a
            routerLink="/kiosk"
            routerLinkActive="bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400"
            (click)="closeMobileMenu()"
            class="block px-4 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800 flex items-center gap-3 dark:text-gray-200"
          >
            <span>🛒</span> Kiosk
          </a>
        }
        @if (isOnboardingCompleted() && !isEventsOrServicesActive()) {
          <a
            [routerLink]="eventsRoute()"
            routerLinkActive="bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400"
            (click)="closeMobileMenu()"
            class="block px-4 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800 flex items-center gap-3 dark:text-gray-200"
          >
            <span>📅</span> {{ eventsLabel() }}
          </a>
        }
        @if (isOnboardingCompleted() && !isRecommendationsActive()) {
          <a
            routerLink="/recommendations"
            routerLinkActive="bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400"
            (click)="closeMobileMenu()"
            class="block px-4 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800 flex items-center gap-3 dark:text-gray-200"
          >
            <span>💡</span> Recommandations
          </a>
        }
      </div>
    </div>
  }
</nav>
